import * as React from 'react';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import SelectField from '../../common/form-controls/SelectField';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';

interface OnPremVPNScopeInputProps {
	direction: FieldHandler<string>
}

const OnPremVPNScopeInput = (props: OnPremVPNScopeInputProps) => {

	const scopeOptions = () => {
		return [
			{ value: PortOpeningRequestsDirection.NewRequest.name, text: PortOpeningRequestsDirection.NewRequest.displayName },
		];
	};
	
	return (
		<SelectField
			label="Request type"
			className="full-width"
			options={scopeOptions()}
			{...props.direction}
		/>
	);
}

export default OnPremVPNScopeInput;